export interface NumberTextOptions {
  allowNegative?: boolean;
  allowDecimal?: boolean;
}

const pattern = ({ allowNegative = true, allowDecimal = true }: NumberTextOptions): RegExp =>
  new RegExp(`^${allowNegative ? '-?' : ''}\\d*${allowDecimal ? '(\\.\\d*)?' : ''}$`);

export const isNumberText = (text: string, options: NumberTextOptions = {}): boolean => pattern(options).test(text);

export const parseNumberText = (text: string): number | null => {
  if (text === '' || text === '-' || text === '.' || text === '-.') return null;
  const n = Number(text);
  return Number.isFinite(n) ? n : null;
};

export const formatNumber = (value: number | null): string => (value === null || Number.isNaN(value) ? '' : String(value));
